import { Box, Typography } from "@mui/material";

import { TextMessage } from "../../../../Chat/types";
import { ChatMessage } from "../../../api/services/chat";

const UserMessage = ({ message }: { message: ChatMessage }) => {
  const { text } = message;
  return (
    <Box sx={styles.userMessageContainer}>
      <Typography sx={styles.userMessageText}>{text}</Typography>
    </Box>
  );
};

export default UserMessage;

const styles = {
  userMessageContainer: {
    alignSelf: "flex-end",
    padding: "10px 14px",
    borderRadius: "8px 0 8px 8px",
    background: "var(--Gray---50, #F5F6F5)",
  },
  userMessageText: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
  },
};
